export enum RoutePaths {
  ACCOUNT = 'account',
  NEW_ACCOUNT = 'new-account',
  ADVANCED = 'advanced',
  APP = 'app',
  CASHDRAWERS = 'cashdrawers',
  CATEGORY = 'category',
  CFD = 'cfd',
  CFD_SETTINGS = 'cfd-settings',
  CLOSING = 'closing',
  COMBINED_REPORTS = 'combinedreports',
  COMPANY = 'company',
  COPY = 'copy',
  CUSTOMERS = 'customers',
  DASHBOARD = 'dashboard',
  DAY = 'day',
  DEVICES = 'devices',
  DISABLED = 'disabled',
  EMAIL = 'email',
  EMPTY = '',
  FDM = 'fdm',
  FLOORS = 'floors',
  GIFTCARDS = 'giftcards',
  GIFTCARDS_TRANSACTIONS = 'giftcard-transactions',
  GROUPS = 'groups',
  HOUR = 'hour',
  INGREDIENT = 'ingredient',
  INGREDIENTS = 'ingredients',
  INVOICE = 'invoice',
  INVOICES = 'invoices',
  IRS = 'irs',
  KITCHEN_SETTINGS = 'kitchen-settings',
  LABOUR = 'labour',
  LAYOUT = 'layout',
  LOGS = 'device_logs',
  LOYALTY = 'loyalty',
  LOYALTY_PROVIDERS = 'loyaltyProviders',
  FINANCIAL_SERVICES = 'financial-services',
  LS_CAPITAL = 'ls-capital',
  LS_PAYMENTS = 'ls-payments',
  MANAGER = 'manager',
  MENU = 'menu',
  MODIFIERS = 'modifiers',
  MONTH = 'month',
  NEW = 'new',
  NOTIFICATION = 'notification',
  NOT_FOUND = '404',
  OVERVIEW = 'overview',
  PAYMENTS = 'payments',
  PRINT = 'print',
  PRINTERS = 'printers',
  PRINTING = 'printing',
  PROCESSING = 'processing',
  PROCESSORS = 'processors',
  PRODUCT = 'product',
  PRODUCTS = 'products',
  RECEIPT = 'receipt',
  RECEIPTS = 'receipts',
  REPORT = 'report',
  REPORTS = 'reports',
  RESTAURANT = 'restaurant',
  RESTAURANT_SETTINGS = 'restaurant-settings',
  REVENUE = 'revenue',
  REVENUE_OVERVIEW = 'revenue-overview',
  SETTINGS = 'settings',
  SHIFT = 'shift',
  STOCK = 'stock',
  SUPPORT = 'support',
  TEMPLATES = 'templates',
  TERMINALS = 'terminals',
  TIMED_EVENTS = 'timedevents',
  TYPES = 'types',
  USER = 'user',
  USERS = 'users',
  VALIDATION = 'validation',
  WAITER = 'waiter',
  WEEK = 'week',
  SUMMARY = 'summary',
  TASKS = 'tasks',
  EXPORT_DATA = 'export',
  LS_ACCOUNTING = 'ls-accounting',
  FISCAL_REPORTS = 'fiscal-reports'
}
